import { render } from "./interesting-bites.vue?vue&type=template&id=84a7a89a&scoped=true"
import script from "./interesting-bites.vue?vue&type=script&lang=js"
export * from "./interesting-bites.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./interesting-bites.vue?vue&type=style&index=1&id=84a7a89a&scoped=true&lang=css"

import exportComponent from "D:\\MY PROJECTS\\VUE_3\\EXCEL_LIBRARY\\excel-library-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84a7a89a"]])

export default __exports__